export default {
  login: 'KenWhite02',
  id: 68158625,
  node_id: 'MDQ6VXNlcjY4MTU4NjI1',
  avatar_url: 'https://avatars.githubusercontent.com/u/68158625?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/KenWhite02',
  html_url: 'https://github.com/KenWhite02',
  followers_url: 'https://api.github.com/users/KenWhite02/followers',
  following_url:
    'https://api.github.com/users/KenWhite02/following{/other_user}',
  gists_url: 'https://api.github.com/users/KenWhite02/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/KenWhite02/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/KenWhite02/subscriptions',
  organizations_url: 'https://api.github.com/users/KenWhite02/orgs',
  repos_url: 'https://api.github.com/users/KenWhite02/repos',
  events_url: 'https://api.github.com/users/KenWhite02/events{/privacy}',
  received_events_url:
    'https://api.github.com/users/KenWhite02/received_events',
  type: 'User',
  site_admin: false,
  name: 'Ken White',
  company: null,
  blog: 'https://ken-portfolio.netlify.app/',
  location: 'Nairobi, Kenya',
  email: null,
  hireable: true,
  bio: 'Self-taught software engineer.',
  twitter_username: 'ken__white',
  public_repos: 11,
  public_gists: 0,
  followers: 30,
  following: 8,
  created_at: '2020-07-11T15:41:34Z',
  updated_at: '2021-02-22T09:46:01Z',
};
